/**
 * Register a new customer in Klaviyo with language
 * @author Lina Arroyo <lina.arroyo@gradiweb.com>
 */

import { registerEmailInKlaviyo } from '../services/klaviyo';
import { $Q } from "../utils/query-selector";
import { currentLang } from '../utils/getLanguage';

export const createCustomerWithLang = (email) => {
  let lang = currentLang;
  registerEmailInKlaviyo(email, lang);
}

let registerButton = $Q(".register-b2c button.btn");
if (registerButton) {
    registerButton.addEventListener('click', () => {
        let email = $Q("#RegisterForm-email").value;
        if(email) {
        createCustomerWithLang(email);
        }
    });
}